import {connect} from 'react-redux';
import SimulatorStepView from '../../../components/views/mx/creditoReal/SimulatorStepView';
import * as CalculatorActions from '../../../actions/CalculatorActions';
import * as WizardMXActions from '../../../actions/WizardMXActions';
import * as LoginActions from '../../../actions/LoginActions';
import * as LoanApplicationActions from '../../../actions/LoanApplicationActions';
import * as WizardValidationUtils from '../../../utils/WizardValidationUtils';
import {withRouter} from 'react-router';
import {FormFieldProps} from '../../../../common/types/components';
import {pushDataLayer} from '../../../../common/utils/GTMUtils';
import {DATA_LAYER} from '../../../../common/constants/LabelConstants';
import {MX_VALUES} from '../../../constants/MX/WizardInputs';
import * as RoutesConstant from '../../../constants/RoutesConstant';
import {SimulatorDataDispatchProps} from '../../../types/mx/creditoReal/containers';
import {CommonCalculatorConfig} from '../../../types/mx/components';
import {isEmpty} from '../../../../common/utils/ValidationUtils';
import {ASSEMBLY_COUNTRY_SELECTED_ACTION} from '../../../actions/CalculatorActions';
import * as ModalActions from '../../../actions/ModalActions';
import {MODAL_TYPE} from '../../../constants/ModalConstants';

const mapStateToProps = (state, {match, landing}) => {
    const calculatorStepViewState = state.creditoReal.ui.calculatorStepView.fieldErrors;
    const {creditoReal: {calculator}, countrySelector, catalogs} = state;
    const globalValidations: CommonCalculatorConfig = state.globalValidations.creditoReal;
    const quotas = calculator.quotas && calculator.quotas.length > 0 ? calculator.quotas[0] : {};
    const assemblyCountryCatalog = state.catalogs.assemblyCountry;
    return {
        calculator,
        catalogs,
        landing,
        globalValidations,
        assemblyCountryCatalog,
        provinces: catalogs.provinces,
        years: catalogs.years,
        brands: catalogs.brands,
        models: catalogs.models,
        versions: catalogs.versions,
        country: countrySelector.countrySelected,
        minPrice: globalValidations.minAllowedVehiclePrice,
        minDownPayment: globalValidations.minDownPayment,
        minDownPaymentValue: Math.ceil((calculator.price >= globalValidations.minAllowedVehiclePrice ?
            calculator.price : globalValidations.minAllowedVehiclePrice) * globalValidations.minDownPayment),
        maxDownPayment: globalValidations.maxDownPayment,

        yearSelectedField: new FormFieldProps(
            calculator.yearSelected, calculatorStepViewState.yearFieldError),
        brandSelectedField: new FormFieldProps(
            calculator.brandSelected, calculatorStepViewState.brandFieldError),
        modelSelectedField: new FormFieldProps(
            calculator.modelSelected, calculatorStepViewState.modelFieldError),
        versionSelectedField: new FormFieldProps(
            calculator.versionSelected, calculatorStepViewState.versionFieldError),
        priceField: new FormFieldProps(
            calculator.price, calculatorStepViewState.priceFieldError),
        downPaymentField: new FormFieldProps(
            calculator.downPayment, calculator.price >= globalValidations.minAllowedVehiclePrice ?
                calculatorStepViewState.downPaymentFieldError : ''),
        monthlyPaymentField: new FormFieldProps(
            calculator.monthlyPayment, calculatorStepViewState.monthlyPaymentFieldError),
        hasCalculatorFieldsError: WizardValidationUtils.hasCalculatorFieldsError(
            calculatorStepViewState.yearFieldError,
            calculatorStepViewState.brandFieldError,
            calculatorStepViewState.modelFieldError,
            calculatorStepViewState.versionFieldError,
            calculatorStepViewState.postalCodeFieldError,
            calculatorStepViewState.priceFieldError,
            calculatorStepViewState.downPaymentFieldError,
            calculatorStepViewState.monthlyPaymentFieldError,
            calculatorStepViewState.assemblyCountryFieldError,
        ),
        postalCodeField: new FormFieldProps(calculator.postalCode, calculatorStepViewState.postalCodeFieldError),
        assemblyCountryField: new FormFieldProps(
            calculator.assemblyCountrySelected,
            calculatorStepViewState.assemblyCountryFieldError
        ),
        postalCodeIsValid: calculatorStepViewState.postalCodeIsValid,
        insuranceIncludesOptions: [{
            id: '1',
            value: true,
            label: 'Deseo incluir el seguro vehicular en el financiamiento',
            defaultChecked: match.params.token ? calculator.hasInsurance : true
        }, {
            id: '2',
            value: false,
            label: 'Deseo pagar mi seguro vehicular de contado',
            defaultChecked: match.params.token ? !calculator.hasInsurance : false
        }],

        hasQuotas: calculator.quotas.length > 0,
        insuranceAmount: quotas.insuranceAmount,
        financingAmount: quotas.financingAmount,
        commissionAmount: quotas.commissionAmount,
        quotasDescription: quotas.description,
        monthlyPayments: quotas.monthlyPayments,

        hasInsurance: calculator.hasInsurance,
        failInsurance: calculator.failInsurance,
        isInsuranceInFinancing: calculator.hasInsurance && !calculator.failInsurance,
        loanApplicationToken: match.params.token,
        defaultMonthlyPayment: MX_VALUES.MONTHLY_PAYMENTS,
        isLoggedIn: !isEmpty(state.profile.accessToken),
        disabledEditVehicle: calculator.isUrlFromPI,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onChangeYear: (year, error) =>
            dispatch(CalculatorActions.YEAR_SELECTED_ACTION.action(year, error)),
        onChangeBrand: (brand, error) =>
            dispatch(CalculatorActions.BRAND_SELECTED_ACTION.action(brand, error)),
        onChangeModel: (model, error) =>
            dispatch(CalculatorActions.MODEL_SELECTED_ACTION.action(model, error)),
        onChangeVersion: (version, error) =>
            dispatch(CalculatorActions.VERSION_SELECTED_ACTION.action(version, error)),
        onChangePostalCode: (postalCode: string, error: string) => {
            dispatch(CalculatorActions.CHANGE_POSTAL_CODE_ACTION.action(postalCode, error));
        },
        onChangePrice: globalValidations => (price, error) => {
            const downPayment = (price >= globalValidations.minAllowedVehiclePrice ? price :
                globalValidations.minAllowedVehiclePrice) * globalValidations.minDownPayment;
            dispatch(CalculatorActions.CHANGE_DOWN_PAYMENT_AFTER_PRICE_ACTION.action(Math.ceil(downPayment), null));
            dispatch(CalculatorActions.CHANGE_PRICE_ACTION.action(price, error));
        },
        onChangeDownPayment: (downPayment, error) =>
            dispatch(CalculatorActions.CHANGE_DOWN_PAYMENT_ACTION.action(downPayment, error)),
        onChangeAssemblyCountry: (assemblyCountry, error) =>
            dispatch(CalculatorActions.ASSEMBLY_COUNTRY_SELECTED_ACTION.action(assemblyCountry, error)),
        onChangeIncludeInsurance: includeInsurance =>
            dispatch(CalculatorActions.HAS_INSURANCE_SELECTED_ACTION.action(includeInsurance.value)),
        onChangeMonthlyPayment: (monthlyPayment, error) =>
            dispatch(CalculatorActions.MONTHLY_PAYMENT_SELECTED_ACTION.action(monthlyPayment, error)),

        onPressNext: (calculator, isLoggedIn) => () => {
            const dataLayerData = {
                year: calculator.yearSelected.value,
                brand: calculator.brandSelected.value,
                model: calculator.modelSelected.value,
                version: calculator.versionSelected.value,
                price: calculator.price,
                downPayment: calculator.downPayment,
                postalCode: calculator.postalCode
            };
            pushDataLayer(DATA_LAYER.QUOTE, dataLayerData);
            if (!isLoggedIn) {
                dispatch(LoginActions.SET_REDIRECT_URL_ACTION.action(RoutesConstant.PERSONAL_DATA_PATH));
            }
            dispatch(WizardMXActions.GO_TO_APPLICANT_DATA_MX_ACTION.action());
            dispatch(LoanApplicationActions.SET_HIGHEST_STEP_ACTION.action(1));
        },
        getLoanApplication: token => () => {
            if (token) {
                dispatch(WizardMXActions.GET_LOAN_APPLICATION_SUMMARY_MX_ACTION.action(token));
                dispatch(WizardMXActions.FILL_CALCULATOR_DATA_MX_ACTION.action());
            }
        },
        onPressUpdate: () => dispatch(WizardMXActions.SAVE_CALCULATOR_DATA_MX_ACTION.action()),
        onPressHelpAssemblyCountryModal: () => {
            const options = {
                closeOnOverlayClick: true,
                size: 'sm'
            };
            dispatch(ModalActions.OPEN_MODAL_DATA_ACTION.action({
                closeBtn: true,
            }, {
                type: MODAL_TYPE.ASSEMBLY_COUNTRY_HELP_VIEW
            }, null, options));
        },
    };
};

const mergeProps = (stateProps, dispatchProps): SimulatorDataDispatchProps => {
    const {loanApplicationToken, monthlyPayments, monthlyPaymentField} = stateProps;
    return {
        ...stateProps,
        ...dispatchProps,
        getLoanApplication: dispatchProps.getLoanApplication(loanApplicationToken),
        monthlyPayments: loanApplicationToken && monthlyPayments ?
            monthlyPayments.map(item => ({...item, defaultChecked: monthlyPaymentField.value.id === item.id})) :
            monthlyPayments,
        onPressNext: dispatchProps.onPressNext(stateProps.calculator, stateProps.isLoggedIn),
        onChangePrice: dispatchProps.onChangePrice(stateProps.globalValidations)
    };
};

const SimulatorStepContainer = withRouter<any, any>(connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(SimulatorStepView));

export default SimulatorStepContainer;
